import { useAuth0 } from '@auth0/auth0-react';
import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import { getUserPermissions, isAuthorized } from '../utils/Permissions';
import { NavDropdown } from 'react-bootstrap';

export const Header = () => {

    const { loginWithRedirect, logout, isAuthenticated, getAccessTokenSilently, user } = useAuth0();
    const username = user && user.name ? user.name : '';
    const LoginButton = () => {
        return (
            <Button
                variant="outline-success"
                onClick={() => loginWithRedirect({
                    appState: {
                        returnTo: window.location.pathname
                    }
                })}
            >
                Login
            </Button>
        );
    };

    const LogoutButton = () => {
        return (
            <Button
                variant="outline-success"
                onClick={
                    () => logout({
                        logoutParams: {
                            returnTo: window.location.origin,
                            clientId: process.env.REACT_APP_IAM_CLIENT_ID
                        }
                    })
                }
            >
                Log Out
            </Button>
        );
    };

    const getPermissions = async () => {
        const token = await getAccessTokenSilently();
        if (isAuthenticated && user && user.sub) {
            const userId = user.sub.split('|')[1];
            await getUserPermissions(token, userId);
            setIsLoading(false);
        }
    }

    //Get necessary data on screen load
    useEffect(() => {
        if (isLoading) {
            getPermissions();
        }
    }, [isAuthenticated]);

    const [isLoading, setIsLoading] = useState(true);

    return (
        <div>
            <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
                <Container>
                    <Navbar.Brand href="/trade">ALM Trading</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav variant="tabs" className="me-auto">
                            {isAuthorized('connectionScreen') && (
                                <Nav.Item>
                                    <Nav.Link href="/connect">Connect</Nav.Link>
                                </Nav.Item>
                            )}
                            {isAuthorized('tradeScreen') && (
                                <Nav.Item>
                                    <Nav.Link href="/trade">Trade</Nav.Link>
                                </Nav.Item>
                            )}
                            {/* <Nav.Item>
                                <Nav.Link href="/performance">Performance</Nav.Link>
                            </Nav.Item> */}
                        </Nav>
                        <Nav>
                            {
                                isAuthenticated && (
                                    <NavDropdown title={username} id="basic-nav-dropdown">
                                        <NavDropdown.Item><LogoutButton /></NavDropdown.Item>
                                    </NavDropdown>
                                )
                            }
                            {
                                !isAuthenticated && (
                                    <LoginButton />
                                )
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

